import React from 'react';
import PropTypes from 'prop-types';
import './DeltaWifiBanner.scss';

const DeltaWifiBanner = ({
  baseRequestUrl,
  matchMedia,
  bannerConfig,
  isAgnostic,
  cityCode,
}) => {
  const bannerData = isAgnostic ? bannerConfig?.agnostic : bannerConfig?.market;
  const martketImageType = cityCode ? bannerConfig?.market.image_type : '';

  let bannerBgImage = '';
  if (matchMedia.sm) {
    bannerBgImage = cityCode ? `url(${baseRequestUrl}DeltaWifi/bannerImages/${cityCode}_desktop.${martketImageType})` : `url(${baseRequestUrl}DeltaWifi/bannerImages/${bannerData?.banner_image_desktop})`;
  } else {
    bannerBgImage = cityCode ? `url(${baseRequestUrl}DeltaWifi/bannerImages/${cityCode}_mobile.${martketImageType})` : `url(${baseRequestUrl}DeltaWifi/bannerImages/${bannerData?.banner_image_mobile})`;
  }

  const deltaLogo = `${baseRequestUrl}DeltaWifi/bannerImages/${bannerConfig?.delta_logo}`;

  const contentDisplay = (headingValue, contentValue, creditValue) => (
    <>
      <h1 className="DeltaWifiBanner__content--title">{headingValue}</h1>
      <p className="DeltaWifiBanner__content--text">{contentValue}</p>
      <p className="DeltaWifiBanner__content--credit">{creditValue}</p>
    </>
  );

  const marketOrAgnosticDisplay = (cityCodeValue) => {
    if (cityCodeValue) {
      const codeContent = bannerData?.code_contents.find((o) => o.code === cityCodeValue);
      const { photo_credit: credit, heading, content } = codeContent;
      return contentDisplay(heading, content, credit);
    }
    const { heading, content, photo_credit: credit } = bannerData;
    return contentDisplay(heading, content, credit);
  };

  return (
    <section className="DeltaWifiBanner">
      <div className="DeltaWifiBanner__wrapper">
        <div
          className="DeltaWifiBanner__image"
          style={{ backgroundImage: bannerBgImage }}
        />
        <div className="container">
          <div className="DeltaWifiBanner__content">
            <div className="DeltaWifiBanner__content--wrapper">
              {marketOrAgnosticDisplay(cityCode)}
            </div>
          </div>
        </div>
      </div>
      {!matchMedia.md && (
        <div className="DeltaWifiBanner__deltaLogoBlock">
          <p className="DeltaWifiBanner__deltaLogoBlock__text">{bannerConfig?.delta_logo_text}</p>
          <img
            src={deltaLogo}
            className="DeltaWifiBanner__logo"
            alt=""
          />
        </div>
      )}
    </section>
  );
};

DeltaWifiBanner.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  bannerConfig: PropTypes.shape({
    name: PropTypes.string,
    photo_credit: PropTypes.string,
    delta_logo_text: PropTypes.string,
    delta_logo: PropTypes.string,
    market: PropTypes.shape({
      image_type: PropTypes.string,
    }),
    agnostic: PropTypes.shape({
    }),
  }).isRequired,
  isAgnostic: PropTypes.bool.isRequired,
  bannerData: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  cityCode: PropTypes.string,
};

DeltaWifiBanner.defaultProps = {
  cityCode: null,
};

export default DeltaWifiBanner;
